// Stok kartı tipleri (eski AddInventoryItem.tsx'ten taşındı).

export interface AddInventoryItemProps {
  open: boolean;
  onClose: () => void;
  branchId?: string;
  itemToEdit?: any; // ✅ YENİ: Düzenleme modu için - any kullanarak type uyumsuzluğunu çöz
  onItemAdded?: (itemId: string, itemName: string) => void; // ✅ YENİ: Ürün eklendikten sonra callback
  onItemUpdated?: (item: InventoryItem) => void;
  prefillName?: string; // ✅ YENİ: Ürün adını otomatik doldur (e-fatura için)
  /** Hızlı ekle penceresinden "Tam karta geç" ile gelen değerler (yalnız yeni kayıt). */
  prefill?: StockCardPrefill;
}

export interface StockCardPrefill {
  name?: string;
  barcode?: string;
  unit?: string;
  vatRate?: number | '';
  vatStatus?: string;
  salePrice?: number | '';
  purchasePrice?: number | '';
  categoryId?: string | null;
  departmentNo?: number | '';
  itemType?: 'PRODUCT' | 'SERVICE';
}

export interface InventoryCategory {
  id: string;
  name: string;
  parentId: string | null;
  level: number;
  createdAt: string;
  branchesId?: string | null;
  isParent?: boolean;
  label?: string;
}

export interface Warehouse {
  id: string;
  name: string;
  address?: string;
  description?: string;
  isDefault?: boolean;
  branchesId?: string | null;
  warehouseType?: string;
}

export interface Brand {
  id: string;
  name: string;
  description?: string;
  website?: string;
  branchesId?: string | null;
}

// Local Branch interface (AddInventoryItem için özel)
export interface LocalBranch {
  id: string;
  name: string;
  address?: string;
  isHeadquarter?: boolean;
}

export interface ExtraFeatureRow {
  tempId: string;
  featureId: string;
  value: string;
}

export interface InventoryItem {
  id: string;
  name: string;
  barcode?: string;
  categoryId?: string | null;
  brandId?: string | null;
  stockCode: string;
  // ⚠️ DEPRECATED: Backend'den gelecek ama frontend'de kullanmayacağız
  quantity?: number; // Geçici - WarehouseStock'tan gelecek
  warehouseId?: string | null; // Geçici - WarehouseStock'tan gelecek
  unit: string;
  purchasePrice: number;
  purchaseCurrency?: string;
  purchasePrice2: number;
  purchaseCurrency2?: string;
  purchasePrice3: number;
  purchaseCurrency3?: string;
  purchaseVendor: string;
  purchaseVendor2: string;
  purchaseVendor3: string;
  salePrice: number;
  saleCurrency?: string;
  salePrice2: number;
  saleCurrency2?: string;
  salePrice3: number;
  saleCurrency3?: string;
  saleCustomer: string;
  saleCustomer2: string;
  saleCustomer3: string;
  desi?: number;
  vatRate?: number;
  vatStatus?: string;
  sctRate?: number;
  sctStatus?: string;
  description?: string;
  isActive: boolean;
  createdAt: string;
  branchesId?: string | null;
  parentItemId?: string | null;
  // LEGACY UYUM: isMainItem karar mekanizmasi degil, gecis alani.
  isMainItem?: boolean;
  isVariantParent?: boolean;
  departmentNo?: number | null;
  // ✅ YENİ SİSTEM: Depo stokları
  warehouseStocks?: {
    id: string;
    productId: string;
    warehouseId: string;
    warehouseName?: string;
    quantity: number;
    createdAt: string;
    updatedAt?: string;
  }[];
}

export const normalizeImageUrls = (rawImageUrl: unknown, rawImageUrls: unknown): string[] => {
  const collected: string[] = [];

  if (typeof rawImageUrl === 'string' && rawImageUrl.trim()) {
    collected.push(...rawImageUrl.split(',').map(x => x.trim()).filter(Boolean));
  }

  if (Array.isArray(rawImageUrls)) {
    collected.push(...rawImageUrls.map(x => String(x).trim()).filter(Boolean));
  } else if (typeof rawImageUrls === 'string' && rawImageUrls.trim()) {
    const asText = rawImageUrls.trim();
    try {
      const parsed = JSON.parse(asText);
      if (Array.isArray(parsed)) {
        collected.push(...parsed.map(x => String(x).trim()).filter(Boolean));
      } else {
        collected.push(...asText.split(',').map(x => x.trim()).filter(Boolean));
      }
    } catch {
      collected.push(...asText.split(',').map(x => x.trim()).filter(Boolean));
    }
  }

  return Array.from(new Set(collected));
};
